<div class="supergraphic"></div>
<div class="page">
    <app-alert
        *ngIf="isLegacyAuthRequired()"
        type="warning"
        class="legacy-auth-alert"
        message="{{ 'home.warning-legacy-auth' | translate }}">
    </app-alert>

    <app-material [material]="!isMobile">
        <div class="header" header>
            <h1><img src="../../../assets/images/atom_v1_logo.png"></h1>
        </div>
        <ng-container body>
            <router-outlet></router-outlet>
        </ng-container>
    </app-material>
</div>
